import FirebaseModel from './firebase-model';

export interface UserInterface {
    id?: string;
    email: string;
    firstName?: string;
    lastName?: string;
    roleIds?: number[];
}

export class User implements FirebaseModel, UserInterface {
    public id?: string;
    public email = '';
    public firstName?: string;
    public lastName?: string;
    public roleIds?: number[];

    constructor(
        email: string,
        id?: string,
        firstName?: string,
        lastName?: string,
        roleIds?: number[],
    ) {
        this.id = id;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.roleIds = roleIds;
    }

    public saveToFirebase(saveData: UserInterface): boolean {
        return true;
    }
}

export function userFromFirebase(firebaseData: any): User {
    return new User(
        firebaseData.email,
        firebaseData.id,
        firebaseData.firstName || '',
        firebaseData.lastName || '',
    );
}

interface FirebaseUser {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
}

